export const Expertise = [
  {
    category: "Languages",
    skills: [
      { icon: "language", name: "English", level: "Good knowledge" },
      { icon: "language", name: "German", level: "Intermediate knowledge" },
      { icon: "language", name: "Russian", level: "Native language" },
      { icon: "language", name: "Hebrew", level: "Intermediate knowledge" },
    ],
  },
  {
    category: "Technical",
    skills: [
      { icon: "scale", name: "Financial management" },
      { icon: "chart", name: "Reporting & analysis" },
      { icon: "repeat", name: "Process automation" },
      { icon: "check", name: "Data validation" },
      { icon: "document", name: "Regulatory reporting" },
      { icon: "globe", name: "International accounting" },
    ],
  },
  {
    category: "Specialized",
    skills: [
      { icon: "briefcase", name: "Microsoft Office" },
      { icon: "pie", name: "Microsoft Power BI" },
      { icon: "zap", name: "Microsoft Power Automate" },
      { icon: "layers", name: "Microsoft Power Platform" },
      { icon: "database", name: "SAP S/4HANA & Fiori" },
      { icon: "terminal", name: "SQL" },
      { icon: "video", name: "Camtasia" },
    ],
  },
  {
    category: "General",
    skills: [
      {
        icon: "activity",
        name: "Ability to quickly absorb and analyze large amounts of information",
      },
      { icon: "search", name: "Strong attention to detail and problem-solving skills" },
      { icon: "bulb", name: "Analytical thinking" },
      { icon: "sitemap", name: "Structured approach to work" },
      { icon: "users", name: "Intercultural cooperation" },
    ],
  },
];
